export default __webpack_public_path__ + "static/media/lending.94b16545.svg";